//#region redux
import { useDispatch } from "react-redux";
import { agingIncomingInvoiceSnoozed } from "store/actions/incomingInvoiceActions";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";
import { LocalizationHelperInstance } from "utils/helpers";

function useAgingIncomingInvoiceSnoozeAction(id: number | string, onActionSuccess?: (id: number | string) => void) {
  const dispatch = useDispatch();

  const onSnoozeInvoiceSuccess = () => {
    dispatch(agingIncomingInvoiceSnoozed(id as number));
    onActionSuccess && onActionSuccess(id);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.AgingIncomingInvoice,
    onSnoozeInvoiceSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Invoice)
  );

  return snoozeAction;
}

export default useAgingIncomingInvoiceSnoozeAction;
